// extracted by mini-css-extract-plugin
module.exports = {"root":"root","colorWeak":"colorWeak","ant-layout":"ant-layout","ant-table":"ant-table","ant-table-tbody":"ant-table-tbody","ant-table-thead":"ant-table-thead"};